import {
    defaultFont,
    inputColors,
} from '../material-kit-pro-react';
import { silverChalice, black } from '../../../constants/Colors';

const customInputStyle = {
    underline: {
        '&:hover:before, &:before': {
            border: `1px solid ${inputColors.hover.borderColor} !important`,
            borderRadius: '3px',
        },
        '&:after': {
            height: '98%',
            transition: 'none',
            border: `1px solid ${inputColors.active.borderColor}`,
            borderRadius: '3px',
        },
        '&:before': {
            height: '98%',
            borderRadius: '3px',
        },
    },
    disabled: {
        '&:hover:before, &:before': {
            backgroundColor: 'transparent !important',
            border: `1px solid ${inputColors.disabled.borderColor} !important`,
        },
    },
    underlineError: {
        '&:after': {
            border: `2px solid ${inputColors.error.borderColor} !important`,
            transform: 'scale(1)',
        },
    },
    underlineSuccess: {
        '&:after': {
            borderColor: inputColors.active.borderColor,
        },
    },
    labelRoot: {
        ...defaultFont,
        color: `${silverChalice} !important`,
        fontWeight: '300',
        fontSize: '14px',
        lineHeight: '1.42857',
        paddingLeft: '10px',
        top: '3px',
    },
    labelRootError: {
        color: inputColors.error.borderColor,
    },
    labelRootSuccess: {
        color: inputColors.active.borderColor,
    },
    labelShrink: {
        color: `${black} !important`,
        transform: 'translate(0, -7px) scale(1)',
        transformOrigin: 'top left',
    },
    feedback: {
        position: 'absolute',
        top: '25px',
        right: '0',
        zIndex: '2',
        display: 'block',
        width: '24px',
        height: '24px',
        textAlign: 'center',
        pointerEvents: 'none',
    },
    marginTop: {
        marginTop: '24px',
    },
    formControl: {
        paddingBottom: '10px',
        position: 'relative',
    },
    input: {
        height: '100%',
        minHeight: '28px',
        paddingLeft: '10px',
        lineHeight: '28px',
        fontWeight: '300',
        color: inputColors.default.textColor,
        '&:disabled': {
            backgroundColor: `${inputColors.disabled.backgroundColor}`,
        },
        boxSizing: 'border-box',
    },
    inputType: {
        height: '28px',
    },
};

export default customInputStyle;
